import c_1_sfx from '@/assets/sound_effects/carbon/c_1.mp3';
import c_2_sfx from '@/assets/sound_effects/carbon/c_2.mp3';
import c_3_sfx from '@/assets/sound_effects/carbon/c_3.mp3';
import c_4_sfx from '@/assets/sound_effects/carbon/c_4.mp3';
import c_5_sfx from '@/assets/sound_effects/carbon/c_5.mp3';
import c_6_sfx from '@/assets/sound_effects/carbon/c_6.mp3';
import c_7_sfx from '@/assets/sound_effects/carbon/c_7.mp3';
import c_8_sfx from '@/assets/sound_effects/carbon/c_8.mp3';
import c_m_1_sfx from '@/assets/sound_effects/carbon_minor/c_m_1.mp3';
import c_m_2_sfx from '@/assets/sound_effects/carbon_minor/c_m_2.mp3';
import c_m_3_sfx from '@/assets/sound_effects/carbon_minor/c_m_3.mp3';
import c_m_4_sfx from '@/assets/sound_effects/carbon_minor/c_m_4.mp3';
import c_m_5_sfx from '@/assets/sound_effects/carbon_minor/c_m_5.mp3';
import c_m_6_sfx from '@/assets/sound_effects/carbon_minor/c_m_6.mp3';
import c_m_7_sfx from '@/assets/sound_effects/carbon_minor/c_m_7.mp3';
import c_m_8_sfx from '@/assets/sound_effects/carbon_minor/c_m_8.mp3';
import e_1_sfx from '@/assets/sound_effects/energy/e_1.mp3';
import e_2_sfx from '@/assets/sound_effects/energy/e_2.mp3';
import e_3_sfx from '@/assets/sound_effects/energy/e_3.mp3';
import e_4_sfx from '@/assets/sound_effects/energy/e_4.mp3';
import e_5_sfx from '@/assets/sound_effects/energy/e_5.mp3';
import e_6_sfx from '@/assets/sound_effects/energy/e_6.mp3';
import e_7_sfx from '@/assets/sound_effects/energy/e_7.mp3';
import e_8_sfx from '@/assets/sound_effects/energy/e_8.mp3';
import { logg } from '@/util/logg';

const carbonSounds = [
	new Audio(c_1_sfx),
	new Audio(c_2_sfx),
	new Audio(c_3_sfx),
	new Audio(c_4_sfx),
	new Audio(c_5_sfx),
	new Audio(c_6_sfx),
	new Audio(c_7_sfx),
	new Audio(c_8_sfx),
];

const carbonMinorSounds = [
	new Audio(c_m_1_sfx),
	new Audio(c_m_2_sfx),
	new Audio(c_m_3_sfx),
	new Audio(c_m_4_sfx),
	new Audio(c_m_5_sfx),
	new Audio(c_m_6_sfx),
	new Audio(c_m_7_sfx),
	new Audio(c_m_8_sfx),
];

const energySounds = [
	new Audio(e_1_sfx),
	new Audio(e_2_sfx),
	new Audio(e_3_sfx),
	new Audio(e_4_sfx),
	new Audio(e_5_sfx),
	new Audio(e_6_sfx),
	new Audio(e_7_sfx),
	new Audio(e_8_sfx),
];

export function playRandomCollision(type: string) {
	const minor_carbon = true;
	let sounds = minor_carbon ? carbonMinorSounds : carbonSounds;

	if (type !== 'carbon') {
		sounds = energySounds;
	}

	const audio = sounds[Math.floor(Math.random() * sounds.length)];

	// Only reset and play if the audio is not currently playing
	if (audio.paused || audio.ended) {
		audio.currentTime = 0;
		audio.volume = 1;
		audio.play().catch(console.error);
	} else {
		// Audio is already playing, do nothing
		logg('Audio already playing, skipping.');
	}
}

const soundUrls = {
	carbon: [
		c_1_sfx,
		c_2_sfx,
		c_3_sfx,
		c_4_sfx,
		c_5_sfx,
		c_6_sfx,
		c_7_sfx,
		c_8_sfx,
	],
	carbon_minor: [
		c_m_1_sfx,
		c_m_2_sfx,
		c_m_3_sfx,
		c_m_4_sfx,
		c_m_5_sfx,
		c_m_6_sfx,
		c_m_7_sfx,
		c_m_8_sfx,
	],
	energy: [
		e_1_sfx,
		e_2_sfx,
		e_3_sfx,
		e_4_sfx,
		e_5_sfx,
		e_6_sfx,
		e_7_sfx,
		e_8_sfx,
	],
};

// Optional: Track playing audio to clean up or check state
const playingAudios = new Set();

export function playRandomCollisionOverlap(type: string) {
	const minor_carbon = true; // Keep your logic here
	let soundKey =
		type === 'carbon'
			? minor_carbon
				? 'carbon_minor'
				: 'carbon'
			: 'energy';

	const sounds = soundUrls[soundKey];
	const randomIndex = Math.floor(Math.random() * sounds.length);
	const audioSrc = sounds[randomIndex];

	// Create a NEW Audio instance for each play
	// This prevents "resetting" the existing playing audio
	const audio = new Audio(audioSrc);
	audio.volume = 1;

	// Optional: If you want to prevent overlapping entirely, check if any audio is playing
	// For most games, allowing overlap (by creating new instances) sounds better.
	// If you MUST skip if any sound is playing:
	if (playingAudios.size > 0) {
		// Skip playing if any sound is currently playing
		return;
	}

	// Add to tracking set
	playingAudios.add(audio);

	audio.play().catch((err) => {
		console.error('Audio play failed:', err);
		playingAudios.delete(audio); // Remove on error
	});

	// Clean up when audio ends
	audio.onended = () => {
		playingAudios.delete(audio);
	};

	// Optional: Also clean up on pause/abort
	audio.onpause = () => playingAudios.delete(audio);
}
